@if (isTopItem) {
  <div
    #tdzEl
    dndDropzone
    class="menu-drop-zone top"
    dndDragoverClass="active"
    [class.cdk-visually-hidden]="!menuDNDService.activeItem"
    [dndDisableIf]="
      !showFunctionalButtons ||
      menuDNDService.menuDisabledStatuses[item.id] ||
      menuDNDService.activeItem === item
    "
    (dndDrop)="onDrop('top')"
    (dragenter)="resetOtherDropzones(tdz)"
    (dragleave)="resetDropzone(tdz)"
  ></div>
}

<div
  class="main-menu-tree-single-container"
  [ngClass]="{
    'padding-left': !showFunctionalButtons,
    'padding-right': !showFunctionalButtons,
    'edit-mode': showFunctionalButtons,
    'view-mode': !showFunctionalButtons,
  }"
>
  <div>
    <div
      class="single-menu-tree-row"
      [ngClass]="{
        'initial-node-margin': mainModules && !showFunctionalButtons,
        'single-menu-tree-row-edit': showFunctionalButtons,
        'list-opened': showChildren,
      }"
      #dzEl
      dndDropzone
      dndDragoverClass="drop-zone-active"
      [dndDropzoneDisabledClass]="showFunctionalButtons ? 'drop-zone-disabled' : 'dummy'"
      [dndDisableIf]="
        !showFunctionalButtons ||
        menuDNDService.menuDisabledStatuses[item.id] ||
        menuDNDService.activeItem === item
      "
      (dndDrop)="onDrop('inside')"
    >
      <span
        (click)="routeTo()"
        class="node-name"
        [matTooltip]="item && item.name && item.name.length > truncateThreshold ? item.name : ''"
        [ngClass]="{
          'editable-element': showFunctionalButtons,
          'item-highlighted': isChosen,
        }"
        [dndDraggable]="item"
        [dndDragImageOffsetFunction]="dragItemOffsetRight"
        [dndDisableIf]="!showFunctionalButtons"
        [dndEffectAllowed]="'all'"
        (dndStart)="onDragStart($event, item)"
        (dndCanceled)="onDragEnd()"
        (dndEnd)="onDragEnd()"
        (dragenter)="resetOtherDropzones(dz)"
        (dragleave)="resetDropzone(dz)"
      >
        @if (hasChildren) {
          <mat-icon
            aria-hidden="false"
            aria-label="Arrow down icon"
            [@rotatedState]="showChildren"
            (click)="toggleDropdown()"
            class="arrow-icon"
          >
            chevron_right
          </mat-icon>
        }
        @if (item.icon) {
          <mat-icon>{{ item.icon }}</mat-icon>
        }
        {{ item.name | truncate: truncateThreshold }}
        @if (showFunctionalButtons) {
          <mat-icon class="drag-handle">drag_indicator</mat-icon>
        }
      </span>

      @if (showFunctionalButtons) {
        <app-menu-tree-buttons
          [item]="item"
          [moduleNumber]="moduleNumber"
          [onlyAdd]="onlyAdd"
          [tenantId]="tenantId"
          [adminPrivilege]="adminPrivilege"
          (showChildren)="reactOnShowChildrenChange($event)"
        ></app-menu-tree-buttons>
      }
    </div>
    @if (showChildren) {
      <div class="container-with-child-elements">
        @for (child of item.children; track child.id; let i = $index) {
          <app-menu-tree-single
            [item]="child"
            [module]="module"
            [moduleNumber]="moduleNumber"
            [tenantId]="tenantId"
            [showFunctionalButtons]="showFunctionalButtons"
            [menuItemsAsRouting]="menuItemsAsRouting"
            [menuMode]="menuMode"
            [isLast]="item.children.length === i + 1"
            [isTopItem]="i === 0"
            [nextItem]="item.children[i + 1]"
            [chosenElementId]="chosenElementId"
            [adminPrivilege]="adminPrivilege"
            (chosenElementClicked)="emitElementClicked($event)"
          ></app-menu-tree-single>
        }
      </div>
    }
  </div>
</div>

<div
  #bdzEl
  dndDropzone
  class="menu-drop-zone bottom"
  [class.increased]="isLast"
  [class.cdk-visually-hidden]="!menuDNDService.activeItem"
  dndDragoverClass="active"
  [dndDisableIf]="
    !showFunctionalButtons ||
    menuDNDService.menuDisabledStatuses[item.id] ||
    menuDNDService.activeItem === item ||
    menuDNDService.activeItem === nextItem
  "
  (dndDrop)="onDrop('bottom')"
  (dragenter)="resetOtherDropzones(bdz)"
  (dragleave)="resetDropzone(bdz)"
></div>
